import { cn } from '@/lib/utils';
import { Trophy, Medal, Award } from 'lucide-react';

interface RankingBadgeProps {
  position: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RankingBadge({ position, size = 'md', className }: RankingBadgeProps) {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const getPositionStyles = () => {
    switch (position) {
      case 1:
        return 'bg-gradient-to-br from-amber-400 to-amber-600 text-white shadow-lg shadow-amber-500/30';
      case 2:
        return 'bg-gradient-to-br from-slate-300 to-slate-500 text-white shadow-lg shadow-slate-400/30';
      case 3:
        return 'bg-gradient-to-br from-amber-600 to-amber-800 text-white shadow-lg shadow-amber-700/30';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getIcon = () => {
    if (position > 3) return null;
    
    const iconClass = cn(iconSizes[size], 'absolute -top-1 -right-1');
    
    switch (position) {
      case 1:
        return <Trophy className={cn(iconClass, 'text-amber-300')} />;
      case 2:
        return <Medal className={cn(iconClass, 'text-slate-200')} />;
      case 3:
        return <Award className={cn(iconClass, 'text-amber-200')} />;
      default:
        return null;
    }
  };

  return (
    <div className={cn('relative', className)}>
      <div 
        className={cn(
          'flex items-center justify-center rounded-full font-bold',
          sizeClasses[size],
          getPositionStyles()
        )}
      >
        #{position}
      </div>
      {getIcon()}
    </div>
  );
}